import {ChangeDetectorRef, Injectable, signal} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ShowLandingService {
  public isLandingShowed = signal(false);

  constructor(
  ) {}

  public setIsLandingShowed(isShowed: boolean) {
    this.isLandingShowed.set(isShowed);
  }
}
